<y42-list-view
  [name]="''"
  [searchLabel]="'Search Functions'"
  [searchPlaceholder]="'Search for function names'"
  [searchFieldPosition]="'inside'"
  [searchFieldAppearance]="'standard'"
  [searchFieldClasses]="'grid-row-search px-3'"
  [canAdd]="false"
  [hasPadding]="false"
  [quickFilterKey]="quickFilterKey"
  [defaultQuickFilters]="state.defaultQuickFilters"
  [columnDefs]="columnDefs"
  [gridOptions]="gridOptions"
  [frameworkComponents]="frameworkComponents"
  (gridReady)="gridReady($event)"
  (gridRowClicked)="onRowClicked($event)"
  (filterSet)="filterSet()"
  (viewReset)="resetView()"
></y42-list-view>
